import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../utils/Loader";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../utils/withRouter";
import { getEventGuideDetails_action } from "../../actions/event_guide_action/event_guide_action"
import { connect } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import $ from 'jquery'
import moment from "moment";

import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import {
    MapView,
    useMapData,
    useMap,
    Label,
    Path,
    Navigation,
} from "@mappedin/react-sdk";
import { FaMapSigns, FaList, FaTimes, FaMapMarkerAlt } from "react-icons/fa";
import Footer from "../../common_components/Footer";
import { toastError } from "../../utils/constants";

const EventGuide = () => {
    const { isLoading, error, mapData } = useMapData({
        key: "mik_yeBk0Vf0nNJtpesfu560e07e5",
        secret: "mis_2g9ST8ZcSFb5R9fPnsvYhrX3RyRwPtDGbMGweCYKEq385431022",
        mapId: "660c0c3aae0596d87766f2da",
    });

    if (isLoading) return <div>Loading map...</div>;
    if (error) return <div>Error: {error.message}</div>;
    if (!mapData) return null;

    return (
        <MapView mapData={mapData} style={{ width: "100%", height: "100vh" }}>
            <RoutingPanel mapData={mapData} />
        </MapView>
    );
}

function RoutingPanel({ mapData }) {
    const { mapView } = useMap();
    const [route, setRoute] = useState(null);
    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);
    const [spaces, setSpaces] = useState([]);
    const [selectedSpace, setSelectedSpace] = useState(null);
    const [spaceColorMap, setSpaceColorMap] = useState({});
    const [highlightedLegendName, setHighlightedLegendName] = useState(null);
    const [highlightedSpaces, setHighlightedSpaces] = useState([]);
    const [showDirections, setShowDirections] = useState(true);
    const [showLegend, setShowLegend] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [EventDetailsList, setEventDetailsList] = useState([]);

    const legendRef = useRef(null);
    const selectedBoxRef = useRef(null);

    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `*, *::before, *::after { box-sizing: border-box; }`;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    const generateColorMap = (spaces) => {
        const colorMap = {};
        const usedColors = new Set();
        const getRandomColor = () => {
            let color;
            do {
                const r = Math.floor(120 + Math.random() * 100);
                const g = Math.floor(120 + Math.random() * 100);
                const b = Math.floor(120 + Math.random() * 100);
                color = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
            } while (usedColors.has(color));
            usedColors.add(color);
            return color;
        };
        spaces.forEach((space) => {
            if (!space.name) return;
            if (!colorMap[space.name]) colorMap[space.name] = getRandomColor();
        });
        return colorMap;
    };
    const dispatch = useDispatch()

    function getEventGuideDetails(name) {
        console.log("name---->", name)
        const formatName = name.replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, "").trim()
       

        // Decode the URL-encoded string
        const decoded = decodeURIComponent(formatName.replace(/\+/g, " "));

        // Remove emoji + variation selectors explicitly
        const cleaned = decoded
            .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, "")
            .replace(/\uFE0F/g, "") // explicitly remove variation selector
            .trim();

        console.log(cleaned); // "Visitors Registration"

        setIsLoading(true)
        dispatch(getEventGuideDetails_action(cleaned))
            .then((data) => {
                if (data.error != 1) {
                    setEventDetailsList(data.data || [])
                }
                else {
                    toastError(data.msg)
                }
                setIsLoading(false)
            })
            .catch((e) => {
                console.log(e);
            });
    }

    const groupSpacesByName = (spaces) => {
        const groups = {};
        spaces.forEach((space) => {
            if (!space.name) return;
            if (!groups[space.name]) groups[space.name] = [];
            groups[space.name].push(space);
        });
        return groups;
    };

    const groupedSpaces = groupSpacesByName(spaces);

    const icon = `<svg xmlns="http://www.w3.org/2000/svg"
     width="48" height="48"
     viewBox="0 0 48 48">
  
  <!-- White circular background -->
  <circle cx="24" cy="24" r="22" fill="white" stroke="black" stroke-width="2"/>
  
  <!-- Play triangle -->
  <polygon points="18,14 34,24 18,34" fill="black"/>
</svg>`

    useEffect(() => {
        if (mapData) {
            mapData.getByType("space").forEach((space) => {
                if (space.name) {
                    mapView.Labels.add(space, space.name, {
                        appearance: {
                            marker: { icon: icon },
                            text: { foregroundColor: 'red' },
                            margin: 10
                        }
                    })
                }
            })
            const allSpaces = mapData.getByType("space").filter((s) => s.name);
            setSpaces(allSpaces);
            const savedFrom = JSON.parse(localStorage.getItem("from"));
            const savedTo = JSON.parse(localStorage.getItem("to"));
            const getSpaceById = (id) => allSpaces.find((s) => s.id == id);
            if (savedFrom) setFrom(getSpaceById(savedFrom.value));
            if (savedTo) setTo(getSpaceById(savedTo.value));
            setSpaceColorMap(generateColorMap(allSpaces));
        }
    }, [mapData]);

    useEffect(() => {
        if (from && to) getRoute();
    }, [from, to]);

    useEffect(() => {
        if (!mapView || !spaces.length || !Object.keys(spaceColorMap).length) return;
        Object.entries(spaceColorMap).forEach(([name, color]) => {
            const group = groupedSpaces[name];
            group?.forEach((space) => {
                mapView.updateState(space, {
                    color,
                    hoverColor: color,
                    interactive: true,
                });
            });
        });
    }, [mapView, spaces, spaceColorMap]);

    useEffect(() => {
        if (!mapView || !spaces.length) return;

        const handleClick = (e) => {
            const coord = e.coordinate;
            const floorId = coord.floorId;
            const THRESHOLD_DEGREES = 0.00001; // ~1 meter or adjust based on map zoom

            const sameFloorSpaces = spaces.filter((s) => s.floor.id === floorId);

            let closestSpace = null;
            let closestDistance = Infinity;

            for (const space of sameFloorSpaces) {
                const center = space.center;
                const label = space.labelPosition;

                const centerDist = Math.hypot(
                    center.longitude - coord.longitude,
                    center.latitude - coord.latitude
                );

                if (centerDist < THRESHOLD_DEGREES && centerDist < closestDistance) {
                    closestDistance = centerDist;
                    closestSpace = space;
                }

                if (label) {
                    const labelDist = Math.hypot(
                        label.longitude - coord.longitude,
                        label.latitude - coord.latitude
                    );

                    if (labelDist < THRESHOLD_DEGREES && labelDist < closestDistance) {
                        closestDistance = labelDist;
                        closestSpace = space;
                    }
                }
            }

            setSelectedSpace(closestSpace);
        };

        mapView.on("click", handleClick);
        return () => mapView.off("click", handleClick);
    }, [mapView, spaces]);




    // useEffect(() => {
    //     if (!mapView || !spaces.length) return;

    //     mapView.Markers.removeAll();
    //     const getIcon = (name) => {
    //         const lower = name.toLowerCase();
    //         if (lower.includes("food") || lower.includes("stall")) return "🍽️";
    //         if (lower.includes("restaurant")) return "🍴";
    //         if (lower.includes("grocery")) return "🛒";
    //         if (lower.includes("washroom") || lower.includes("toilet")) return "🚻";
    //         if (lower.includes("mall office")) return "🏢";
    //         if (lower.includes("store")) return "🛍️";
    //         return "📍";
    //     };

    //     spaces.forEach((space) => {
    //         const html = `
    //     <div class="dynamic-marker" style="
    //       display: flex; flex-direction: column; align-items: center;
    //       background: rgba(255,255,255,0.95); padding: 5px 7px; border-radius: 10px;
    //       box-shadow: 0 2px 6px rgba(0,0,0,0.3); font-size: 12px;
    //       pointer-events: none; transform: scale(1); transition: transform 0.2s ease;">
    //       <div style="font-size: 24px;">${getIcon(space.name)}</div>
    //       <div style="font-weight: bold; font-size: 12px;">${space.name}</div>
    //     </div>
    //   `;
    //         try {
    //             mapView.Markers.add(space, html, {
    //                 anchor: "top",
    //                 rank: "always-visible",
    //                 interactive: false,
    //             });
    //         } catch (err) {
    //             console.warn("Marker error:", space?.name, err);
    //         }
    //     });
    // }, [mapView, spaces]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                selectedSpace &&
                selectedBoxRef.current &&
                !selectedBoxRef.current.contains(e.target)
            ) {
                setSelectedSpace(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [selectedSpace]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                highlightedLegendName &&
                legendRef.current &&
                !legendRef.current.contains(event.target)
            ) {
                highlightedSpaces.forEach((space) => {
                    const originalColor = spaceColorMap[space.name] || "#CCCCCC";
                    mapView?.updateState(space, {
                        color: originalColor,
                        outlineColor: "#00000000",
                    });
                });
                mapView?.Markers.removeAll();
                setHighlightedSpaces([]);
                setHighlightedLegendName(null);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [highlightedLegendName, highlightedSpaces, mapView, spaceColorMap]);

    useEffect(() => {
        if (selectedSpace?.name) {
            getEventGuideDetails(selectedSpace.name);
        }
    }, [selectedSpace]);

    useEffect(() => {
        if (!selectedSpace && mapView && spaces.length) {
            spaces.forEach((space) => {
                const originalColor = spaceColorMap[space.name] || "#CCCCCC";
                mapView.updateState(space, {
                    color: originalColor,
                    outlineColor: "#00000000",
                });
            });
            // mapView.Markers.removeAll();
        }
    }, [selectedSpace, mapView, spaces, spaceColorMap]);

    const handleLegendClick = (name) => {
        if (!mapView || !groupedSpaces[name]) return;

        // Reset previous highlights
        highlightedSpaces.forEach((space) => {
            const originalColor = spaceColorMap[space.name] || "#CCCCCC";
            mapView.updateState(space, {
                color: originalColor,
                outlineColor: "#00000000",
            });
        });

        mapView.Markers.removeAll();

        const group = groupedSpaces[name];

        // Highlight current group
        group.forEach((space) => {
            mapView.updateState(space, {
                color: "#FFFFFF",
                outlineColor: "#0066ff",
                outlineWidth: 2,
            });

            const html = `
      <div class="dynamic-marker bounce" style="
        display: flex; flex-direction: column; align-items: center;
        animation: bounce 1s infinite;">
        
        <svg viewBox="0 0 384 512" width="24" height="32" xmlns="http://www.w3.org/2000/svg">
          <path fill="#EA4335" d="M192 0C86 0 0 86 0 192c0 77.7 112.9 202.2 170.7 265.1 11.6 12.3 30.9 12.3 42.5 0C271.1 394.2 384 269.7 384 192 384 86 298 0 192 0zm0 272c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"/>
          <circle cx="192" cy="192" r="48" fill="white"/>
        </svg>
      </div>
      <div style="font-weight: bold; font-size: 12px; color: #333;">${space.name}</div>
    `;

            try {
                mapView.Markers.add(space, html, {
                    anchor: "top",
                    rank: "always-visible",
                    interactive: false,
                });
            } catch (err) {
                console.warn("Failed to add marker:", err);
            }
        });

        // ✅ Set correct floor
        mapView.setFloor(group[0].floor);

        // ✅ Use entire group in transform
        const transform = mapView.Camera.getFocusOnTransform(group, {
            minZoomLevel: 6,
            bearing: mapView.Camera.bearing,
            pitch: mapView.Camera.pitch,
        });

        mapView.Camera.animateTo({
            ...transform,
            duration: 4000,
        });

        setHighlightedSpaces(group);
        setHighlightedLegendName(name);
    };

    const getRoute = async () => {
        if (!from || !to || !mapData || (from == to)) return;
        try {
            const directions = await mapData.getDirections(from, to, true);
            if (!directions) return;
            setRoute(directions);
            mapView.setFloor(from.floor);
            mapView.Camera.animateTo({ position: from.center, duration: 1500 });
        } catch (err) {
            console.error("Route error:", err);
        }
    };

    const options = spaces
        .map((s) => ({ value: s.id, label: s.name }))
        .sort((a, b) => a.label.localeCompare(b.label));

    const getSpaceById = (id) => spaces.find((s) => s.id == id);

    return (

        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <ToastContainer />
            <ExhibitorHeader />
            <style>{`
                                  @keyframes bounce {
                                    0%, 100% { transform: translateY(0); }
                                    50% { transform: translateY(-10px); }
                                  }
                                `}</style>

            {/* Toggle Buttons */}
            <button
                onClick={() => setShowDirections(prev => !prev)}
                title={showDirections ? "Hide Directions" : "Show Directions"}
                style={{
                    position: "absolute", top: 90, left: showDirections ? 300 : 20,
                    zIndex: 1, padding: "0px 8px 5px 8px", fontSize: 20, borderRadius: "50%",
                    backgroundColor: "#0066ff", color: "white", border: "none", cursor: "pointer"
                }}
            >
                {showDirections ? <FaTimes /> : <FaMapSigns />}
            </button>


            <button
                onClick={() => setShowLegend(prev => !prev)}
                title={showLegend ? "Hide Legend" : "Show Legend"}
                style={{
                    position: "absolute", bottom: showLegend ? 294 : 85, right: 8,
                    zIndex: 8, padding: "0px 8px 5px 8px", fontSize: 20, borderRadius: "50%",
                    backgroundColor: "#0066ff", color: "white", border: "none", cursor: "pointer"
                }}
            >
                {showLegend ? <FaTimes /> : <FaList />}
            </button>


            {/* Directions Panel */}
            {showDirections && (
                <div style={{
                    position: "absolute", top: 95, left: 20, background: "white",
                    borderRadius: 12, boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                    padding: 16, width: 300, fontFamily: "sans-serif", textAlign: 'left'
                }}>
                    <h3>🧭 Directions</h3>
                    <label>From:</label>
                    <Select
                        options={options}
                        value={from ? { value: from.id, label: from.name } : null}
                        onChange={(s) => {
                            if (s) {
                                const selected = { value: s.value, label: s.label };
                                setFrom(getSpaceById(s.value));
                                localStorage.setItem("from", JSON.stringify(selected));
                            } else {
                                setFrom(null);
                                setRoute(null);
                                localStorage.removeItem("from");
                            }
                        }}
                        placeholder="Select a start location"
                        isClearable
                    />

                    <label style={{ marginTop: 8, display: "block" }}>To:</label>
                    <Select
                        options={options}
                        value={to ? { value: to.id, label: to.name } : null}
                        onChange={(s) => {
                            if (s) {
                                const selected = { value: s.value, label: s.label };
                                setTo(getSpaceById(s.value));
                                localStorage.setItem("to", JSON.stringify(selected));
                            } else {
                                setTo(null);
                                setRoute(null);
                                localStorage.removeItem("to");
                            }
                        }}
                        placeholder="Select a destination"
                        isClearable
                    />

                    {/* <button
            style={{
              marginTop: 16, padding: "8px 16px", backgroundColor: "#0066ff",
              color: "white", border: "none", borderRadius: "6px", cursor: "pointer", width: "100%"
            }}
            onClick={getRoute}
            disabled={!from || !to}
          >
            Show Route
          </button> */}
                </div>
            )}

            {/* Selected Space Info */}
            {selectedSpace && EventDetailsList.length > 0 && (
                <div ref={selectedBoxRef} style={{
                    position: "absolute", top: 100, right: 20, width: 300, backgroundColor: "#fff",
                    borderRadius: 16, boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                    padding: 20, fontFamily: "system-ui, sans-serif", zIndex: 9
                }}>
                    <div
                        onClick={() => setSelectedSpace(null)}
                        style={{
                            position: "absolute", top: 10, right: 12, fontSize: 20,
                            fontWeight: "bold", color: "#666", cursor: "pointer"
                        }}
                    >
                        &times;
                    </div>
                    <h2 style={{ margin: "0 0 10px" }}>{selectedSpace.name}</h2>
                    {/* <p><strong>Floor:</strong> {selectedSpace.floor?.name}</p> */}
                    <p><strong>Description:</strong> {EventDetailsList[0].description}</p>
                    <p><strong>Type:</strong> {EventDetailsList[0].type}</p>
                    <p><strong>Area:</strong> {EventDetailsList[0].area_sqm}</p>
                </div>
            )}

            {/* Labels */}
            {spaces.map((space) => {
                const color = spaceColorMap[space.name] || "#888";
                const isSelected = selectedSpace?.id === space.id;
                const bgColor = isSelected ? "#7b003f" : color;

                return (
                    <Label
                        key={space.id}
                        target={space}
                        options={{ interactive: true }}
                        text={`${space.name}`}
                        // onClick={() => setSelectedSpace(space)}
                        style={{
                            backgroundColor: bgColor,
                            color: "white",
                            padding: "3px 8px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                        }}
                    />
                );
            })}

            {/* Route Path */}
            {route && (
                <>
                    <Path coordinate={route.coordinates} options={{ color: "blue" }} />
                    <Navigation directions={route} />
                </>
            )}

            {/* Legend */}
            {showLegend && (
                <div ref={legendRef} style={{
                    position: "absolute", bottom: 80, right: 20, background: "white",
                    padding: 12, borderRadius: 10, boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                    fontFamily: "sans-serif", zIndex: 7, fontSize: 14,
                    height: '240px', overflowY: "auto"
                }}>
                    <h4 style={{ margin: "0 0 8px" }}>Legend</h4>
                    {Object.entries(spaceColorMap).sort(([a], [b]) => a.localeCompare(b)).map(([name, color]) => (
                        <div
                            key={name}
                            onClick={() => handleLegendClick(name)}
                            style={{
                                display: "flex", alignItems: "center", marginBottom: 4,
                                cursor: "pointer", padding: "4px 6px", borderRadius: 6,
                                backgroundColor: highlightedLegendName === name ? "#f0f0f0" : "transparent"
                            }}
                        >
                            <div style={{
                                width: 14, height: 14, backgroundColor: color,
                                marginRight: 8, borderRadius: 3
                            }} />
                            <span>{name}</span>
                        </div>
                    ))}
                </div>
            )}
            <Footer />
        </>
    );
}


export default withRouter(connect(null, { getEventGuideDetails_action })(EventGuide));